<dx-load-panel [(visible)]="visible"
               [animation]="animation"
               [shadingColor]="shadingColor"
               message=""
               [showIndicator]="true"
               indicatorSrc="assets/Content/Images/spinner.gif"
               [showPane]="false"
               [hideOnOutsideClick]="false">
  <dxo-position of="#screen">
  </dxo-position>
</dx-load-panel>